enum ProjectStage {
  Assessment = 1,
  Sourcing = 2,
  Ongoing = 3,
  Completed = 4,
  Cancelled = 5,
  Archived = 6,
  /** Terminal bid workspace; may only move to Cancelled. Not part of the project lifecycle. */
  Bid = 7
}

/** Display order for left-nav assigned stage groups (Bid above Assessment). */
export const projectStageDisplayOrder: ProjectStage[] = [
  ProjectStage.Bid,
  ProjectStage.Assessment,
  ProjectStage.Sourcing,
  ProjectStage.Ongoing,
  ProjectStage.Completed,
  ProjectStage.Cancelled,
  ProjectStage.Archived
];

export const getProjectStageDisplayIndex = (stage: ProjectStage): number => {
  const index = projectStageDisplayOrder.indexOf(stage);
  return index === -1 ? projectStageDisplayOrder.length : index;
};

export default ProjectStage;
